module.exports = __webpack_public_path__ + "static/media/facebook-logo-626.03b32c04.jpg";